import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import HotComics from './components/HotComics';
import CategoryNav from './components/CategoryNav';
import LatestUpdates from './components/LatestUpdates';
import FeatureSection from './components/FeatureSection';
import FAQSection from './components/FAQSection';

export default function Home() {
  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '99漫画',
    url: 'https://99manga.com',
    logo: 'https://99manga.com/logo.png',
    description: '推荐类似4399漫画网的免费好看漫画平台，韩漫日漫国漫全集大全',
    sameAs: [
      'https://weibo.com/99manga',
    ],
    address: {
      '@type': 'PostalAddress',
      addressCountry: 'CN',
      addressRegion: '广东省',
      addressLocality: '广州市',
      streetAddress: '天河区漫画创意园B座3层',
    },
    contactPoint: {
      '@type': 'ContactPoint',
      email: 'contact@99manga.com',
    },
  };

  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '99漫画',
    url: 'https://99manga.com',
    description: '推荐类似4399漫画网的免费好看漫画平台，韩漫日漫国漫全集大全，下拉式阅读追更收藏',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://99manga.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const webPageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '99漫画 - 推荐类似4399漫画网的免费好看漫画平台',
    url: 'https://99manga.com/',
    description: '寻找类似4399漫画网的同类型漫画平台？99漫画为你推荐免费好看的韩漫、日漫、国漫全集大全，支持下拉式阅读，轻松追更收藏热门漫画。',
    isPartOf: {
      '@type': 'WebSite',
      name: '99漫画',
      url: 'https://99manga.com',
    },
    primaryImageOfPage: {
      '@type': 'ImageObject',
      url: 'https://99manga.com/images/og-image.jpg',
    },
  };

  return (
    <>
      <ScrollToTop />
      <script type="application/ld+json">
        {JSON.stringify(orgSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(websiteSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(webPageSchema)}
      </script>
      <Navbar />
      <main>
        <HeroSection />
        <HotComics />
        <CategoryNav />
        <LatestUpdates />
        <FeatureSection />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}